/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import { Grid, Button, IconButton } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const styles = theme => ({
    root: {
        background: '#ffffff',
        boxShadow: '0 1px 0 rgba(32, 90, 64, 0.08)',
        position: 'relative',
        zIndex: 10,
        [theme.breakpoints.down(600)]: {
            boxShadow: '0 1px 0 rgba(32, 90, 64, 0.06)'
        }
    },
    container: {
        maxWidth: 960,
        margin: 'auto',
        padding: '14px 24px',
        [theme.breakpoints.down(600)]: {
            padding: '12px 16px'
        }
    },
    logo: {
        width: 180,
        height: 38,
        flexShrink: 0,
        background: 'url(https://uusi.kilpailu.fi/images/tutkimuskeskus-2026-full-green-icon.svg)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left center',
        cursor: 'pointer',
        [theme.breakpoints.down(600)]: {
            width: 160,
            height: 34
        }
    },
    grid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    menuWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4
    },
    menuItem: {
        fontWeight: 500,
        padding: '8px 14px',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: '0.88rem',
        color: '#3a5048',
        transition: 'color 0.2s ease, background 0.2s ease',
        borderRadius: 8,
        textDecoration: 'none',
        display: 'block',
        '&:hover': {
            color: '#205a40',
            background: 'rgba(32, 90, 64, 0.06)'
        }
    },
    menuItemActive: {
        color: '#205a40',
        background: 'rgba(32, 90, 64, 0.08)',
        fontWeight: 600
    },
    link: {
        textDecoration: 'none'
    },
    isNotMobile: {
        display: 'flex',
        [theme.breakpoints.down(600)]: {
            display: 'none'
        }
    },
    isMobile: {
        display: 'none',
        [theme.breakpoints.down(600)]: {
            display: 'flex'
        }
    },
    // Badge showing active status
    statusBadge: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        background: 'rgba(32, 90, 64, 0.08)',
        borderRadius: 20,
        fontSize: '0.75rem',
        fontWeight: 600,
        color: '#205a40',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        letterSpacing: '0.2px'
    },
    statusDot: {
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: '#10b981',
        animation: '$pulse 2s ease-in-out infinite'
    },
    '@keyframes pulse': {
        '0%, 100%': { opacity: 1 },
        '50%': { opacity: 0.5 }
    },
    // Mobile menu button
    menuButton: {
        marginLeft: 8,
        padding: 10,
        borderRadius: 10,
        color: '#3a5048',
        '&:hover': {
            background: 'rgba(32, 90, 64, 0.06)'
        }
    },
    menuIcon: {
        fontSize: '1.1rem'
    },
    // Mobile menu overlay
    mobileMenuOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: 100,
        opacity: 0,
        visibility: 'hidden',
        transition: 'opacity 0.25s ease, visibility 0.25s ease',
        [theme.breakpoints.up(600)]: {
            display: 'none'
        }
    },
    mobileMenuOverlayOpen: {
        opacity: 1,
        visibility: 'visible'
    },
    // Mobile menu panel
    mobileMenu: {
        position: 'fixed',
        top: 0,
        right: 0,
        width: '280px',
        maxWidth: '85vw',
        height: '100vh',
        background: '#ffffff',
        zIndex: 101,
        transform: 'translateX(100%)',
        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '-4px 0 24px rgba(0, 0, 0, 0.15)',
        [theme.breakpoints.up(600)]: {
            display: 'none'
        }
    },
    mobileMenuOpen: {
        transform: 'translateX(0)'
    },
    mobileMenuHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        borderBottom: '1px solid rgba(32, 90, 64, 0.08)'
    },
    mobileMenuTitle: {
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: '0.9rem',
        fontWeight: 600,
        color: '#1a2e23'
    },
    closeButton: {
        padding: 8,
        borderRadius: 8,
        color: '#5a7a6a',
        '&:hover': {
            background: 'rgba(32, 90, 64, 0.06)'
        }
    },
    mobileMenuItems: {
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 12px',
        gap: 4
    },
    mobileMenuItem: {
        fontWeight: 500,
        padding: '14px 16px',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: '0.95rem',
        color: '#3a5048',
        transition: 'background 0.2s ease',
        borderRadius: 10,
        textDecoration: 'none',
        display: 'block',
        '&:hover': {
            background: 'rgba(32, 90, 64, 0.06)'
        }
    }
})

const menuItems = [
    {
        label: 'Etusivu',
        url: ''
    },
    {
        label: 'Tutkimukset',
        url: '&ca=tutkimukset'
    },
    {
        label: 'Ota yhteyttä',
        url: '&ca=teeta-oma-tutkimus'
    }
]

class PageHeader extends PureComponent {
    state = {
        isMenuOpen: false
    }

    handleToggleMenu = () => {
        this.setState({ isMenuOpen: !this.state.isMenuOpen })
    }

    handleCloseMenu = () => {
        this.setState({ isMenuOpen: false })
    }

    render() {
        const { classes, baseUrl } = this.props
        const { isMenuOpen } = this.state

        return (
            <div className={classes.root + ' page-header'}>
                <Grid container className={classes.container}>
                    <Grid item xs={12} className={classes.grid}>
                        {/* Logo */}
                        <a href={baseUrl}>
                            <div className={classes.logo + ' page-logo'} />
                        </a>

                        {/* Desktop Navigation */}
                        <div className={classes.menuWrapper + ' ' + classes.isNotMobile}>
                            {menuItems.map((menuItem, key) => (
                                <a key={key} href={baseUrl + menuItem.url} className={classes.link}>
                                    <div className={classes.menuItem}>{menuItem.label}</div>
                                </a>
                            ))}
                        </div>

                        <div style={{ flexGrow: 1 }} />

                        {/* Status badge - replaces decorative circles */}
                        <div className={classes.statusBadge + ' ' + classes.isNotMobile}>
                            <span className={classes.statusDot} />
                            Käynnissä
                        </div>

                        {/* Mobile menu button */}
                        <div className={classes.isMobile}>
                            <IconButton
                                className={classes.menuButton}
                                onClick={this.handleToggleMenu}
                                aria-label="Avaa valikko"
                            >
                                <FontAwesomeIcon className={classes.menuIcon} icon={['far', 'bars']} />
                            </IconButton>
                        </div>

                        {/* Mobile menu overlay */}
                        <div
                            className={`${classes.mobileMenuOverlay} ${isMenuOpen ? classes.mobileMenuOverlayOpen : ''}`}
                            onClick={this.handleCloseMenu}
                        />

                        {/* Mobile menu panel */}
                        <div className={`${classes.mobileMenu} ${isMenuOpen ? classes.mobileMenuOpen : ''}`}>
                            <div className={classes.mobileMenuHeader}>
                                <span className={classes.mobileMenuTitle}>Valikko</span>
                                <IconButton
                                    className={classes.closeButton}
                                    onClick={this.handleCloseMenu}
                                    aria-label="Sulje valikko"
                                >
                                    <FontAwesomeIcon icon={['far', 'times']} />
                                </IconButton>
                            </div>
                            <div className={classes.mobileMenuItems}>
                                {menuItems.map((menuItem, key) => (
                                    <a key={key} href={baseUrl + menuItem.url} className={classes.link}>
                                        <div className={classes.mobileMenuItem}>{menuItem.label}</div>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(PageHeader)
